/*
         * För nya behörigheter är det bra att följa modulprefixen nedan för att enkelt lägga in och separera liknande behörigheter.
         * Nya behörigheter måste läggas in under både GrantType.cs och GrantName.cs samt "Module.cs" i motsvarande modul för att kunna användas i klienten.
         * Enkelt och smidigt att uppdatera behörigheter istället för att manuellt uppdatera 5 olika databaser vid varje justering.
         * 
         * Krävs även ändring i UserGrant.cs för att lägga ihop namnet korrekt.
         * 
         * Och ändring i frontend under util/grants.js för att kunna använda granten där.
         * 
         * Fyll bara på längst ner med en kommentar kring vilken modul det gäller.
         */

export const TYPES = {
    Dashboard_ViewOrderInfo : 0,
    Dashboard_ViewShippingInfo : 1,
    Dashboard_ReportArrivalDate : 2,
    // Order
    Order_ViewOrderInformation : 3,
    Order_CreateOrder : 4,
    Order_AddOrderComment : 5,
    Order_ModifyOrderTexts : 6,
    Order_ToggleCallOff : 7,
    Order_EditPrice : 8,
    Order_SetOrderBackToPreliminary : 9,
    Order_QuickEdit: 60,
    Order_CloneOrder: 62,
    Order_OverrideReservation: 63,
    // Stock
    Stock_ViewStock : 10,
    Stock_RestrictedExmill : 11, //För greaseproof främst, denna är hårdkodad till 4 veckor vid datahämtning för stock om Grant finns 
    // Customer Profile
    CustomerProfile_ViewCustomerProfile : 12,
    CustomerProfile_ViewCustomerAllocation : 13,
    CustomerProfile_EditCustomerAllocation : 14,
    CustomerProfile_AddAllocationYear : 15,
    // Allocation
    Allocation_ViewAllocation : 16,
    Allocation_AddAllocationComments : 17,
    Allocation_ViewAllocationComments : 18,
    // Admin
    Admin_ViewAdministrationMenu : 19,
    Admin_ViewUserList : 20,
    Admin_CreateUsers : 21,
    Admin_CreateRoles : 22,
    Admin_ModifyUsers : 23,
    Admin_ViewUserRoles : 24,
    Admin_ManageUserRoles : 25,
    Admin_EditGlobalSettings : 26,
    Admin_ViewCapacityAllocation : 27,
    Admin_EditCapacityAllocation : 28,
    Admin_AddCapacityComments : 29,
    Admin_ViewCapacityComments : 30,
    Admin_ManagePendingUsers : 31,
    // General
    General_RestrictedOrderStatusProduced : 32, //Handlar om exmill som inte ska synas för GP
    General_DownloadPackingAndInvoice : 33,
    General_ExportToExcel : 34,
    General_ExpandOrderDetails : 35,
    General_ExpandOrderStatus : 36,
    General_ViewProfile : 37,
    General_ShowSpecificOrderTexts : 38,

    // Nya - läggs här för att snabbt se senaste nummer, med prefix
    Allocation_SearchAndCorporate : 39,
    Stock_CreateCalloff : 40,
    Stock_SeeCalloff : 41,
    Stock_SetCallOffBackToPreliminary : 42,
    News_SeeNews : 43,
    News_CreateNews : 44,
    Document_SeeDocuments : 45,
    Document_CategoryCertificate : 46,
    Document_CategoryDeliveryPlan : 47,
    Document_CategoryImages : 48,
    Document_CategoryInformation : 49,
    Document_CategoryPresentation : 50,
    Document_CategorySQR : 51,
    Document_CategoryProductDevelopment: 52,
    Document_CategoryTechnicalSpecification: 53,
    Admin_EditTwoFactorSettings: 55,
    TDS_SeeSheets: 56,
    TDS_Help_SeeBrandNames: 57,
    TDS_Help_Lab: 58,
    Order_CancelReleased: 59
 }